var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { ButtonSize } from './button.type';
import React from 'react';
import { IconPowerButton } from '@axafr-btc-ds/icons';
import { PrimaryButton } from './primary-button';
export var LogoutButton = React.forwardRef(function (props, ref) { return (React.createElement(PrimaryButton, __assign({}, props, { ref: ref, align: 'left', size: ButtonSize.m, icon: IconPowerButton }))); });
